import React, { useEffect, useState, useCallback } from 'react';
import { Box, Alert } from '@mui/material';
import DashboardLayout from './DashboardLayout.js';
import ManageMembershipTransactions from './MembershipTransactions/ManageMembershipTransactions.js';
import PageLoader from '../../../Reusable/PageLoader.js';
import baseURL from '../config.js';

const MembershipTransactions = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchApplications = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${baseURL}/admin/membership-applications?limit=500`, {
        credentials: 'include',
      });
      if (!res.ok) throw new Error('Failed to fetch membership applications.');
      const data = await res.json();
      setApplications(data.applications);
    } catch (err) {
      console.error(err);
      setError(err.message || 'An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchApplications();
  }, [fetchApplications]);

  if (loading) {
    return (
      <DashboardLayout>
        <PageLoader message="Loading membership applications..." />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <ManageMembershipTransactions applications={applications} onRefresh={fetchApplications} />
    </DashboardLayout>
  );
};

export default MembershipTransactions;
